<template>
  <div class="products-page">
    <section
      class="products"
      id="products"
      :class="{ 'with-cart': isOpenCart }"
    >
      <v-container :maxWidth="calcWidth">
        <div class="categories" v-if="!isLoading">
          <img
            v-if="true"
            class="svg flower-01"
            src="/images/hanging-flowers.svg"
          />
          <v-slide-group
            :show-arrows="isLaptop || isDesktop ? true : false"
            :max="6"
          >
            <v-slide-group-item>
              <CategoryItem
                v-for="category in categories"
                :key="category.categoryId"
                :loading="loading"
                :categoryImage="imageUrl(category.categoryImage)"
                :title="category.categoryName"
                :id="category.categoryId"
                :slug="category.slug"
                :rootCategory="stableRootCategory"
                :categoryData="category"
              />
            </v-slide-group-item>
          </v-slide-group>
        </div>
        <div>
          <ProductCategorySkeleton v-if="isLoading" />
        </div>
        <div
          class="d-flex justify-space-between flex-column flex-xl-row flex-md-column flex-sm-column"
        >
          <!-- <div class="d-flex align-center"> -->
          <baseSearch
            :mode="'normal'"
            :placeholderText="$t('BaseSearch.placeholder')"
            :minWidth="$store.getters.isMobile ? '100%' : '500px'"
            class="d-flex align-start search"
            @reloadInfiniteScroll="reloadInfiniteScroll"
          />
          <!-- </div> -->

          <Filters
            @reloadInfiniteScroll="reloadInfiniteScroll"
            v-if="!isLoading"
          />
        </div>
        <div
          v-if="stableRootCategory"
          class="title-breadcrumb-wrapper d-flex align-center"
        >
          <h1 v-if="categoryTitle" class="category-title">
            {{ categoryTitle }}
          </h1>
          <Breadcrumb v-if="breadcrumbItems.length" :items="breadcrumbItems" />
        </div>
        <NotFound
          v-if="
            !isLoading &&
            productsList.length === 0 &&
            !numberOfProducts &&
            !isFirstPageWithoutSearch
          "
          title="לא הצלחנו למצוא את מה שחיפשת"
        />
        <ProductCardSkeleton v-if="isLoading" />
        <v-infinite-scroll
          v-if="productsList.length && !isLoading"
          @Load="loadMore"
        >
          <div class="grid">
            <productItem
              v-for="product in sortedProducts"
              :product="product"
              @moreInfo="showProductModal(product)"
              :key="product"
              :auth-status="isAuthenticated"
              :priceListId="getCustomerPriceListId"
              @sendRquestAddToPriceList="updatePartRquestAddToPriceList"
              @updateProduct="updateProduct"
              @toggleFavorite="handleToggleFavorite"
              :isQuantityBtnDisable="isQuantityBtnDisable"
            />
          </div>
          <template v-slot:empty>
            <div>לא נמצאו עוד מוצרים</div>
          </template>
        </v-infinite-scroll>

        <!-- Category Description Section -->
        <div
          v-if="currentCategoryDescription"
          class="category-description-section"
        >
          <div
            class="category-description-content"
            v-html="currentCategoryDescription"
          ></div>
        </div>

        <!-- <div class="d-flex justify-center mt-4">
          <v-pagination
            v-if="productsList.length"
            v-model="page"
            :length="totalPages"
            :total-visible="isMobile ? 4 : 7"
            rounded="circle"
            @update:modelValue="handlePageChange"
          ></v-pagination>
        </div> -->
      </v-container>
    </section>
    <section class="cart" :class="{ 'cart-open': isOpenCart }">
      <div class="cart-content">
        <Cart :isCartOpen="isOpenCart" @openCart="toggleCart" />
      </div>
    </section>
    <!-- Add modal -->
    <v-dialog
      v-model="dialog"
      width="1200px"
      scroll-strategy="none"
      @click:outside="closeModal"
    >
      <ProductModal
        @closeModel="closeModal"
        @updateProduct="updateProduct"
        v-if="selectedProduct"
        :product="selectedProduct"
        :priceListId="getCustomerPriceListId"
        :isAuthenticated="isAuthenticated"
      />
    </v-dialog>
    <v-btn
      v-if="!isOpenCart"
      class="scroll-to-top"
      icon="mdi-arrow-up"
      size="default"
      base-color="#2c2c2c75"
      @click="scrollToTop"
    />
  </div>
</template>

<script>
import BaseSearch from "../menus/BaseSearch.vue";
import { mapGetters } from "vuex";
import {
  updateMetaTags,
  getMetaTagsForCategoryFromAPI,
  getMetaTagsForProducts,
} from "../../utils/metaTags";
import { isPendingNavigationModalToggle } from "../../utils/productModalNavigation";

import productItem from "../helpers/productItem.vue";
import CategoryItem from "../helpers/Categories/CategoryItem.vue";
import ProductModal from "../UI/modals/ProductModal.vue";
import Filters from "../helpers/ProductsFilters.vue";
import Cart from "../menus/Cart.vue";
import NotFound from "../helpers/NotFound.vue";
import Breadcrumb from "../UI/Breadcrumb.vue";
import config from "../../config";
import ProductCardSkeleton from "../UI/ProductCardSkeleton.vue";
import ProductCategorySkeleton from "../UI/ProductCategorySkeleton.vue";
export default {
  components: {
    BaseSearch,
    productItem,
    CategoryItem,
    ProductModal,
    Filters,
    Cart,
    NotFound,
    Breadcrumb,
    ProductCardSkeleton,
    ProductCategorySkeleton,
  },
  BeforeCreate() {
    if (this.$route.query.page) {
      this.page = parseInt(this.$route.query.page);
    }
  },
  async mounted() {
    this.getCategories(this.$route.params.rootCategory);
    this.openLoginModel();
    this.getPartsTagsHandler();

    // The watcher with immediate:true will handle the initial product fetch
    // So we don't need to call getProducts here anymore

    // Update meta tags for the current page
    this.updatePageMetaTags();
    // Initialize page from route query
  },
  watch: {
    isUserGuest: {
      async handler() {
        this.$route.query.page = 1;
        await this.$router.replace({
          query: { ...this.$route.query },
        });

        await this.reloadInfiniteScroll();
        await this.getProducts("isUserGuest");
      },
    },
    "$route.params": {
      async handler(newParams) {
        if (!newParams) return;

        // Handle product modal from params (for full URL with productId)
        await this.syncSelectedProductFromRoute(newParams.productId);

        // Reuse the classification router.js already computed for this
        // exact navigation (beforeEach runs, then this watcher fires)
        // instead of re-deriving it from newParams/oldParams — a bare
        // params diff can't tell modal-toggle from real-category-change
        // here, because the Products route has no rootCategory/
        // subCategory params at all.
        if (isPendingNavigationModalToggle()) {
          return;
        }

        this.stableRootCategory = newParams.rootCategory;
        this.stableSubCategory = newParams.subCategory;

        await this.getCategories(this.stableRootCategory);
        await this.reloadInfiniteScroll();
        await this.getPartsTagsHandler();
        await this.getProducts("$route.params");
        this.updatePageMetaTags();
      },
      deep: true,
      immediate: true,
    },
    "$route.query.productId": {
      async handler(productId) {
        await this.syncSelectedProductFromRoute(productId);
      },
      immediate: true,
    },
    "$route.query.search": {
      async handler(newQuery, oldQuery) {
        // Only trigger if search actually changed (not on initial load with no search)
        if (newQuery !== oldQuery) {
          await this.reloadInfiniteScroll();
          await this.getProducts("$route.query.search");
        }
      },
      deep: true,
      immediate: false,
    },
    // Watch for other query params changes (like filters, tags, etc.)
    "$route.query": {
      async handler(newQuery, oldQuery) {
        // Skip if only page, search, or productid changed (handled separately)
        const newQueryWithoutPageSearch = { ...newQuery };
        const oldQueryWithoutPageSearch = { ...oldQuery };
        delete newQueryWithoutPageSearch.page;
        delete oldQueryWithoutPageSearch.page;
        delete newQueryWithoutPageSearch.search;
        delete oldQueryWithoutPageSearch.search;
        delete newQueryWithoutPageSearch.productid;
        delete oldQueryWithoutPageSearch.productid;
        delete newQueryWithoutPageSearch.productId;
        delete oldQueryWithoutPageSearch.productId;

        if (
          JSON.stringify(newQueryWithoutPageSearch) !==
          JSON.stringify(oldQueryWithoutPageSearch)
        ) {
          await this.reloadInfiniteScroll();
          await this.getPartsTagsHandler();
          await this.getProducts("$route.query");
        }
      },
      deep: true,
      immediate: false,
    },
    // Add watch for page parameter in URL
    //gome remove page watcher since no longer there
    // "$route.query.page": {
    //   immediate: true,
    //   handler(newPage) {
    //     if (newPage) {
    //       this.page = parseInt(newPage);
    //     } else {
    //       this.page = 1;
    //     }
    //   },
    // },
  },
  data() {
    return {
      page: 1,
      itemsPerPage: 12,
      numberOfProducts: 0,
      isQuantityBtnDisable: false,
      productsList: [],
      moreInfoModel: false,
      moreInfoProduct: {},
      loading: false,
      categories: [],
      dialog: false,
      selectedProduct: null,
      previousPath: null,
      previousQuery: null,
      stableRootCategory: null,
      stableSubCategory: null,
    };
  },
  methods: {
    async syncSelectedProductFromRoute(productId) {
      if (!productId) {
        if (this.dialog) {
          this.dialog = false;
          this.selectedProduct = null;
        }
        return;
      }

      const existingProduct = this.productsList.find(
        (product) => product.part === Number(productId),
      );

      if (existingProduct) {
        this.selectedProduct = existingProduct;
        this.dialog = true;
        return;
      }

      const product = await this.getProductById(productId);
      const productFromCart = await this.getProductFromCart(productId);
      const productWithQuantCart = {
        ...product,
        quant: productFromCart?.quant || 0,
      };

      if (product) {
        this.selectedProduct = productWithQuantCart;
        this.dialog = true;
      }
    },
    handleToggleFavorite({ part, isFavorite }) {
      if (isFavorite || this.$route.params?.rootCategory !== "favorites") {
        return;
      }
      const productIndex = this.productsList.findIndex(
        (product) => product.part === part,
      );
      if (productIndex !== -1) {
        this.productsList.splice(productIndex, 1);
        this.numberOfProducts = Math.max(0, this.numberOfProducts - 1);
      }
    },
    updatePartRquestAddToPriceList(partId) {
      const productIndex = this.productsList.findIndex(
        (product) => product.part === partId,
      );
      if (productIndex !== -1) {
        this.productsList[productIndex] = {
          ...this.productsList[productIndex],
          sentPriceListRequest: true,
        };
      }
    },
    reloadInfiniteScroll() {
      // Reset products list and trigger load more
      this.productsList = [];
      this.page = 1;
    },
    async loadMore({ done }) {
      // Check if we've already loaded all products
      if (this.productsList.length >= this.numberOfProducts) {
        await done("empty");
        return;
      }

      try {
        const nextPage = this.page + 1;
        // Check if we've reached the last page
        if (nextPage > this.totalPages) {
          await done("empty");
          return;
        }
        //gome no longer needed for url param, keep page locally in component
        // Update the page in the URL and router
        // await this.handlePageChange(nextPage);
        this.page = nextPage;

        // Fetch products
        const res = await this.getProducts("loadMore");

        if (res) {
          await done("ok");
        }
      } catch (error) {
        console.error("Load more error:", error);
      }
    },
    imageUrl(image) {
      // check if the image is url
      if (image && image?.startsWith("http")) {
        return image;
      } else {
        return `${config.baseURL}${image}`;
      }
    },
    getPartsTagsHandler() {
      this.$nextTick(async () => {
        if (!this.$route.params) return;
        await this.$store.dispatch("Category/getPartsTags", {
          rootCategory: this.$route.params.rootCategory,
          category: this.$route.params.subCategory,
        });
      });
    },
    openLoginModel() {
      // Don't show login modal for CategoryProducts routes (root category pages)
      if (this.$route.name === "CategoryProducts") {
        return;
      }

      // Don't show login modal when viewing a specific product
      if (this.$route.params.productId || this.$route.query.productId) {
        return;
      }

      if (!this.isAuthenticated && !this.isUserGuest)
        this.$store.dispatch("AuthModule/setLoginModel", true);
    },
    async getCategories(rootCategory) {
      try {
        if (rootCategory !== "favorites") {
          const categoriesRes = await this.$store.dispatch(
            "Category/getCategories",
            { rootCategory },
          );
          this.categories = categoriesRes.data;
        } else {
          this.categories = [];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getProducts(caller) {
      // console.log("caller");
      console.log(caller);

      const queryWithoutProductId = { ...this.$route.query };
      delete queryWithoutProductId.productId;
      delete queryWithoutProductId.productid;

      let tags = {};
      if (this.$store.getters["Category/getPartsTags"].length) {
        for (let key in queryWithoutProductId) {
          if (
            this.$store.getters["Category/getPartsTags"].some(
              (tag) => tag.name == key,
            )
          )
            tags[key] = queryWithoutProductId[key].split(",");
        }
      }

      try {
        // Build the request object, only including params that have values
        const requestParams = {
          ...queryWithoutProductId,
          tags,
          page: this.page,
        };

        // Add root category if it exists
        if (this.$route.params?.rootCategory) {
          requestParams.root = this.$route.params.rootCategory;
        }

        // Add subcategory if it exists
        if (this.$route.params?.subCategory) {
          requestParams.category = this.$route.params.subCategory;
        }

        let res = await this.$store.dispatch("Parts/findParts", requestParams);
        this.numberOfProducts = res.count;
        console.log(this.page);

        // if (this.page === 1 && this.$route.query.page) {
        //   this.productsList = res.parts;
        // } else {
        //   this.productsList = [...this.productsList, ...res.parts];
        // }
        // gome: Always append unless it's the first page
        if (this.page === 1) {
          this.productsList = res.parts; // Replace for first page
        } else {
          this.productsList = [...this.productsList, ...res.parts]; // Append
        }
        await this.$store.dispatch("Orders/updateQuantOfPartByCart", {
          products: this.productsList,
        });
        return true;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
    async getProductById(id) {
      let res = await this.$store.dispatch("Parts/findParts", { id });
      return res.parts[0];
    },
    async getProductFromCart(id) {
      return this.getCart?.OrderLines?.find((order) => order.Part.part == id);
    },
    async updatePageMetaTags() {
      let metaTags;
      const productId =
        this.$route.params.productId || this.$route.query.productId;

      if (productId) return;
      if (
        this.$route.name === "CategoryProducts" &&
        this.$route.params.rootCategory
      ) {
        // Handle category pages - fetch category data from API to get metaTitle and metaDescription
        metaTags = await getMetaTagsForCategoryFromAPI(
          this.$store,
          this.$route.params.rootCategory,
          this.$route.params.subCategory,
        );
      } else if (this.$route.name === "Products") {
        // Handle general products page /products
        metaTags = getMetaTagsForProducts();
      } else {
        return; // Don't update meta tags for other pages
      }

      // Update the meta tags in the DOM
      updateMetaTags(
        metaTags.title,
        metaTags.description,
        metaTags.canonicalUrl,
      );
    },
    toggleCart() {
      if (this.isMobile || this.isTablet) {
        this.scrollToElement("header");
      }
    },
    openMoreInfoModel(product) {
      this.moreInfoModel = true;
      this.moreInfoProduct = product;
    },
    async updateProduct(obj) {
      if (!obj?.product || this.isQuantityBtnDisable) return;

      this.isQuantityBtnDisable = true;
      const { product, quantity } = obj;
      const lineOrdi = this.getLineByPart(product.part);

      const line = {
        Part: { ...product },
        quant: quantity,
        ...(lineOrdi && { ordi: lineOrdi }),
      };

      if (quantity > 0) {
        await this.$store.dispatch("Orders/updateCart", line);
      } else if (line.ordi) {
        await this.$store.dispatch("Orders/removeProductFromCart", line);
      }

      this.isQuantityBtnDisable = false;
    },
    scrollToElement(name) {
      const element = document.getElementById(name);
      if (element) {
        element.scrollIntoView({
          block: "start",
        });
      }
    },
    //gome remove page change handler since we no longer need to change query params
    // async handlePageChange(newPage) {
    // Update URL with new page number while preserving other query params
    // this.scrollToElement("products");
    // await this.$router.replace({
    //   query: {
    //     ...this.$route.query,
    //     page: newPage,
    //   },
    // });
    // },
    showProductModal(product) {
      // Store the current listing route so we can restore it on close.
      // We keep this in sessionStorage as well as component data because a
      // hard refresh while the modal is open would otherwise lose it.
      const returnQuery = { ...this.$route.query };
      delete returnQuery.productId;
      delete returnQuery.productid;

      sessionStorage.setItem(
        "productModalReturnRoute",
        JSON.stringify({
          path: this.$route.path,
          query: returnQuery,
        }),
      );

      // Also keep in component data for same-route navigations (Products → Products)
      // where the component instance is reused.
      this.previousPath = this.$route.path;
      this.previousQuery = returnQuery;

      this.$router.push({
        path: `/products/${product.part}`,
      });
    },

    closeModal() {
      this.dialog = false;
      this.selectedProduct = null;

      // Restore the previous listing route when we opened the modal from it.
      // First try component data (preserved when component instance is reused),
      // then fall back to sessionStorage (survives component destruction).
      if (this.previousPath) {
        this.$router.push({
          path: this.previousPath,
          query: this.previousQuery || {},
        });
        this.previousPath = null;
        this.previousQuery = null;
        sessionStorage.removeItem("productModalReturnRoute");
        return;
      }

      const stored = sessionStorage.getItem("productModalReturnRoute");
      if (stored) {
        sessionStorage.removeItem("productModalReturnRoute");
        try {
          const returnRoute = JSON.parse(stored);
          this.$router.push({
            path: returnRoute.path,
            query: returnRoute.query || {},
          });
          return;
        } catch (e) {
          // Fall through to default behavior
        }
      }

      if (this.$route.query.productId || this.$route.query.productid) {
        const query = { ...this.$route.query };
        delete query.productId;
        delete query.productid;

        this.$router.push({
          path: this.$route.path,
          query,
        });
        return;
      }

      if (this.$route.params.productId) {
        this.$router.push({
          path: "/products",
        });
        return;
      }

      this.$router.back();
    },
    async updateQueryWithPage(pageNumber) {
      await this.$router.replace({
        query: {
          ...this.$route.query,
          page: pageNumber,
        },
      });
    },
    scrollToTop() {
      document.getElementById("app").scrollIntoView({ behavior: "smooth" });
    },
  },
  computed: {
    urlQuery() {
      return {
        ...this.$route.query,
        page: this.page,
      };
    },
    isFirstPageWithoutSearch() {
      return this.page === 1 && !this.$route.query.search;
    },
    categoryTitle() {
      const rootSlug = this.stableRootCategory;
      const subCategorySlug = this.stableSubCategory;

      // If we have a subcategory, show its name
      if (subCategorySlug && this.categories.length) {
        const category = this.categories.find(
          (c) => c.slug === subCategorySlug,
        );
        if (category) {
          return category.categoryName;
        }
      }

      // If we only have a root category, show its name
      if (rootSlug && rootSlug !== "favorites") {
        const rootCategory = this.$store.getters[
          "Category/getRootCategories"
        ].find((rc) => rc.path === rootSlug);
        if (rootCategory) {
          return rootCategory.title;
        }
      }

      // For favorites
      if (rootSlug === "favorites") {
        return this.$t ? this.$t("favorites") : "מועדפים";
      }

      // Default to "Products" or translation
      return this.$t ? this.$t("products") : "מוצרים";
    },
    currentCategoryDescription() {
      const subCategorySlug = this.stableSubCategory;

      // If we have a subcategory, show its description
      if (subCategorySlug && this.categories.length) {
        const category = this.categories.find(
          (c) => c.slug === subCategorySlug,
        );
        if (category?.categoryDescription) {
          return category.categoryDescription;
        }
      }

      return null;
    },
    breadcrumbItems() {
      const items = [];

      // Get root category from URL params
      const rootSlug = this.stableRootCategory;

      if (rootSlug && rootSlug !== "favorites") {
        // Find root category from store
        const rootCategory = this.$store.getters[
          "Category/getRootCategories"
        ].find((rc) => rc.path === rootSlug);

        if (rootCategory) {
          items.push({
            label: rootCategory.title,
            to: `/${rootSlug}`,
          });
        }

        // If there's a selected subcategory
        const subCategorySlug = this.stableSubCategory;
        if (subCategorySlug && this.categories.length) {
          const category = this.categories.find(
            (c) => c.slug === subCategorySlug,
          );
          if (category) {
            items.push({
              label: category.categoryName,
              to: `/${rootSlug}/${subCategorySlug}`,
            });
          }
        }
      } else if (rootSlug === "favorites") {
        items.push({
          label: this.$t ? this.$t("favorites") : "מועדפים",
          to: "/favorites",
        });
      }

      return items;
    },
    sortedProducts() {
      const products = [...this.productsList];
      return products;
      // remove the sort beasue  it's dont work with the initfy scroll need to make in from the backend
      // return products.sort((partOne, partTwo) => {
      //   if (!partOne.isFromPriceList && partTwo.isFromPriceList) {
      //     return 1;
      //   }

      //   if (partOne.isFromPriceList && !partTwo.isFromPriceList) {
      //     return -1;
      //   }

      //   return 0;
      // });
    },
    calcWidth() {
      return "95vw";
    },
    formattedProducts() {
      return this.sortedProducts.map((product) => {
        return {
          key: product.part,
          value: product.part,
          text: product.partdes,
        };
      });
    },
    currentCategoryPath() {
      return this.$route.params?.rootCategory || null;
    },
    isOnCategoryPage() {
      return (
        this.$route.name === "Products" ||
        this.$route.name === "CategoryProducts"
      );
    },
    ...mapGetters({
      getCart: "Orders/getCart",
      getLineByPart: "Orders/getLineByPart",
      isOpenCart: "Orders/getIsCartModelOpen",
      isMobile: "isMobile",
      isLaptop: "isLaptop",
      isTablet: "isTablet",
      isDesktop: "isDesktop",
      isAuthenticated: "AuthModule/isAuthenticated",
      getCustomerPriceListId: "AuthModule/getCustomerPriceListId",
      isUserGuest: "AuthModule/isUserGuest",
      getRootCategories: "Category/getRootCategories",
      isLoading: "Parts/getIsLoading",
    }),
    totalPages() {
      return Math.ceil(this.numberOfProducts / this.itemsPerPage);
    },
  },
};
</script>

<style scoped lang="scss">
.products-page {
  display: flex;
  flex-direction: row;
  position: relative;
  z-index: 1;
}

.products {
  flex: 1;
  transition: width 0.3s ease;
  margin: 0px 50px;
  margin-top: 50px;

  .categories {
    position: relative;
    margin-bottom: 40px;
    .flower-01 {
      top: -80px;
      left: 120px;
      position: absolute;
    }
  }

  &.with-cart {
    width: 70%;
  }
}

.cart {
  height: fit-content;
  position: sticky;
  top: 80px;
  width: 0;
  left: 20px;
  transition: width 0.3s ease;
  box-shadow: 0px 4px 40px #00000020;
  border-radius: 10px;
  overflow: hidden;
  align-self: flex-start;

  &.cart-open {
    width: 30%;
    min-width: 400px;
  }

  .cart-content {
    padding: 20px;
    height: 100%;
    overflow-y: auto;
    max-height: 100vh;
  }
}

.search {
  width: 100%;
  margin-bottom: 50px;
  margin-top: 15px;
}

.title-breadcrumb-wrapper {
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.category-title {
  font-size: 2.5rem;
  font-weight: 600;
  color: $primaryColor;
  margin: 0;
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(390px, 1fr));
  gap: 20px;
  grid-auto-rows: 1fr;
}

.product-modal {
  // min-height: 700px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  background: white;
  padding: 0px 50px 50px 50px;
  border-radius: 8px;
}
.scroll-to-top {
  position: fixed;
  bottom: 160px;
  right: 50px;
  z-index: 99;
  transition: opacity 0.3s;
  color: white !important;

  &:hover {
    opacity: 1;
  }
}

.isLaptop {
  .products {
    max-width: 95% !important;
    &.with-cart {
      width: 50%;
    }
  }
  .cart {
    &.cart-open {
      width: 45%;
    }
  }
}
.isTablet {
  .grid {
    grid-template-columns: repeat(auto-fill, minmax(500px, 1fr)) !important;
  }
  .cart {
    top: 80px !important;
  }
}

.isTablet,
.isMobile {
  .categories {
    margin-bottom: 10px;
    margin-top: 20px;
  }
  .cart-content {
    padding: 0px;
  }
  .cart-open {
    width: 100%;
    background: white;
    min-width: unset;
  }
  .products-page {
    flex-direction: column;
  }

  .search {
    margin-bottom: 20px;
  }

  .products {
    margin: 0px;
    width: 100% !important;
    .v-container {
      padding: 8px !important;
    }
  }

  .cart {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    height: 100%;
    z-index: 100;

    &:not(.cart-open) {
      height: 0;
    }
  }
  .grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.category-description-section {
  margin-top: 60px;
  padding: 40px 20px;
  background-color: #f9f9f9;
  border-radius: 8px;

  .category-description-content {
    max-width: 1200px;
    margin: 0 auto;
    line-height: 1.8;
    color: #333;

    ::v-deep {
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-top: 1.5em;
        margin-bottom: 0.5em;
        color: $primaryColor;
      }

      p {
        margin-bottom: 1em;
      }

      ul,
      ol {
        margin-bottom: 1em;
        padding-right: 20px;
      }

      img {
        max-width: 100%;
        height: auto;
        border-radius: 4px;
      }

      a {
        color: $primaryColor;
        text-decoration: underline;
      }
    }
  }
}

// Add this to your mobile styles
.isMobile {
  .grid {
    gap: 10px;
  }
  .scroll-to-top {
    bottom: 120px;
    right: 15px;
  }
  .title-breadcrumb-wrapper {
    justify-content: space-between;
  }
  .category-title {
    font-size: 1.5rem;
  }
}
</style>
